<template>
  <div class="student-layout">
    <div class="header">
      <div class="logo">众鑫驾考学习系统</div>
      <div class="user-info">
        <span class="user-detail">
          <i class="el-icon-user"></i> {{ user.username || '-' }}
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-s-custom"></i> {{ user.realName || '未设置姓名' }}
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-reading"></i> {{ user.subjectName || '未绑定科目' }}
        </span>

        <el-button
            type="text"
            style="color: #fff; margin-left: 20px; font-size: 18px;"
            @click="toggleDarkMode"
            :title="$store.state.isDarkMode ? '切换亮色模式' : '切换夜间模式'"
        >
          <i :class="$store.state.isDarkMode ? 'el-icon-sunny' : 'el-icon-moon'"></i>
        </el-button>

        <el-button
            type="text"
            class="logout-btn"
            @click="handleLogout"
        >
          退出登录
        </el-button>
      </div>
    </div>

    <div class="main">
      <div class="content-full">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api/auth'
import { removeToken } from '@/utils/auth'

export default {
  name: 'StudentLayout',
  computed: {
    user() {
      return this.$store.state.userInfo || {}
    }
  },
  methods: {
    toggleDarkMode() {
      this.$store.commit('TOGGLE_DARK_MODE')
    },
    async handleLogout() {
      try {
        const res = await logout()
        if (res.code === 200) {
          this.$message.success('退出成功')
        }
      } catch (err) {
        console.log('退出失败', err)
      } finally {
        removeToken()
        this.$store.commit('CLEAR_USER_INFO')
        this.$router.replace('/login')
      }
    }
  }
}
</script>

<style scoped>
/* 终极防爆布局 */
.student-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止全局出现乱七八糟的滚动条 */
}

.header {
  height: 60px;
  background: #409EFF;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  flex-shrink: 0; /* 保证头部高度永不被压缩 */
}

.logo {
  flex: 1;
  text-align: left; /* Logo 靠左更协调 */
  font-size: 20px;
  font-weight: bold;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-detail {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.user-detail i {
  margin-right: 4px;
}

.logout-btn {
  color: #fff !important;
  font-weight: 500;
  margin-left: 20px;
}

.logout-btn:hover {
  color: #f56c6c !important;
}

.main {
  flex: 1;
  display: flex;
  overflow: hidden; /* 将滚动权交给 content-full */
}

.content-full {
  flex: 1;
  width: 100%;
  padding: 24px;
  overflow-y: auto; /* 只有内容区可以上下滚动 */
  background: #f5f7fa;
  box-sizing: border-box; /* 核心修复：防止 padding 撑爆屏幕导致横向溢出 */
}
</style>